import React, {useEffect} from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'
import AOS from 'aos'
import 'aos/dist/aos.css'
const Services = () => {
  useEffect(() => {
    AOS.init()
  })
  return (
    <section id='services'>
      <h5 data-aos="fade-up">What I offer</h5>
      <h2 data-aos="fade-up">Services</h2>

      <div className="container services__container" data-aos="fade-up">
        <article className="services">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icons' />
              <p>Design and develop responsive websites from scratch.</p>

            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p> Create web applications tailored to specific business needs. </p>

            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p> Craft visually appealing and user-friendly user interfaces (UI). </p>

            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Ensure cross-browser compatibility and responsive design.</p>

            </li>

          </ul>
        </article>
        {/* -- New One -- */}
        <article className="services">
          <div className="service__head">
            <h3>e-Commerce</h3>
          </div>
          <ul className="service__list">
          <li>
              <BiCheck className='service__list-icons' />
              <p>Develop custom e-commerce platforms with features like product catalog, shopping cart, and payment processing.</p>

            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Integrate third-party payment gateways and shipping solutions. </p>

            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Integrate popular CMS platforms like WordPress, Drupal, or Joomla.</p>

            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Identify and resolve performance bottlenecks in web applications. </p>

            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Implement caching, code minification, and other optimization techniques.</p>

            </li>

          </ul>
        </article>
{/* -- New One -- */}
        <article className="services">
          <div className="service__head">
            <h3>Backend Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icons' />
              <p>Build robust and scalable server-side applications and APIs.</p>

            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Implement databases and optimize data management system</p>

            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Develop authentication and authorization systems for secure access</p>

            </li>
            <li>
              <BiCheck className='service__list-icons' />
              <p>Build RESTful APIs for seamless integration with third-party services.</p>

            </li>
           
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Services